export default __webpack_public_path__ + "static/media/about-section-02.631c1b9f.webp";